<article class="flex justify-end items-center py-4">
  <p class="text-[.9rem] text-gray-700">
    Stuck on the form? use
    <a
      href="mailto:support@CourthouseComputerSystems.com?subject=Support%20request%20from%20the%20Probate%20app"
      class="font-semibold underline underline-offset-2 text-gray-700"
      >Contact support</a
    >
  </p>
</article>
